module.exports = __webpack_public_path__ + "static/business_what@2x-3d0f145d9c0b0c35c4b76d877720fcfd.png";